import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
  standalone: true,
  providers: [],
  imports: [RouterModule],
  selector: 'daas-consulting-app-production-root',
  styleUrl: './app.component.scss',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {
  constructor(iconRegistry: MatIconRegistry) {
    iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
    const borderColor = environment?.borderColor || 'transparent';
    const versionColor =
      borderColor === 'transparent'
        ? 'rgb(156 163 175 / var(--tw-text-opacity))'
        : 'white';
    const borderWidth = environment?.borderWidth || '0';
    document.documentElement.style.setProperty('--border-color', borderColor);
    document.documentElement.style.setProperty('--border-width', borderWidth);
    document.documentElement.style.setProperty('--version-color', versionColor);
  }
}
